import * as THREE from 'three';
import { getGroupOrderZ } from '@/utils/enumHelper';
import { createMeshFromLine } from '@/utils/threejsHelper';
import { disposeO3D } from '../js/threejsHelper';
let group_vehiclePlanning = null; //主车规划线
let visible_group = true;
const material_vehiclePlanning_pathList = new THREE.MeshBasicMaterial({
  color: 0x11264f,
  side: THREE.DoubleSide,
  opacity: 0.5,
  transparent: true,
});
const material_vehiclePlanning_trajectoryList = new THREE.MeshBasicMaterial({
  color: 0x2585a6,
  side: THREE.DoubleSide,
  opacity: 0.5,
  transparent: true,
});

/***
 * 主车规划线；
 */
export const loadVehiclePlanning = (
  vehicleData,
  threejs_global,
  vehicleParams,
) => {
  if (!visible_group) {
    if (group_vehiclePlanning) {
      group_vehiclePlanning.visible = false;
    }
    return;
  }
  if (vehicleData && vehicleData.planning) {
    if (group_vehiclePlanning) {
      disposeO3D(group_vehiclePlanning);
    }

    group_vehiclePlanning = new THREE.Group();
    let group_routing_order = getGroupOrderZ('pnc_planning');
    group_vehiclePlanning.position.set(
      vehicleData.origin.x,
      vehicleData.origin.y,
      group_routing_order.z,
    );
    group_vehiclePlanning.timeEx = 5;
    threejs_global.scene.add(group_vehiclePlanning);

    let width = vehicleParams.width || 0.5;
    //pathList
    {
      if (vehicleData.planning.pathList?.length > 0) {
        let heartShape = new THREE.Shape();
        let pointsList = createMeshFromLine(
          vehicleData.planning.pathList,
          width,
        );
        pointsList.forEach((e, index) => {
          if (index == 0) {
            heartShape.moveTo(e.x, e.y);
          } else {
            heartShape.lineTo(e.x, e.y);
          }
        });
        const geometry_shape = new THREE.ShapeGeometry(heartShape);
        const mesh = new THREE.Mesh(
          geometry_shape,
          material_vehiclePlanning_pathList,
        );
        mesh.position.set(0, 0, 0.001);
        mesh.renderOrder = -10;
        group_vehiclePlanning.add(mesh);
      }
    }
    //trajectoryList
    {
      if (vehicleData.planning.trajectoryList?.length > 0) {
        let heartShape = new THREE.Shape();
        let pointsList = createMeshFromLine(
          vehicleData.planning.trajectoryList,
          width,
        );
        pointsList.forEach((e, index) => {
          if (index == 0) {
            heartShape.moveTo(e.x, e.y);
          } else {
            heartShape.lineTo(e.x, e.y);
          }
        });
        const geometry_shape = new THREE.ShapeGeometry(heartShape);
        const mesh = new THREE.Mesh(
          geometry_shape,
          material_vehiclePlanning_trajectoryList,
        );
        mesh.position.set(0, 0, 0.002);
        mesh.renderOrder = -10;
        group_vehiclePlanning.add(mesh);
      }
    }
    {
      //planning_init_point

      if (vehicleData.planning?.planningInitPoint) {
        const geometry = new THREE.SphereGeometry(0.05, 32, 16);
        const material = new THREE.MeshBasicMaterial({
          color: 0xd71345,
          side: THREE.DoubleSide,
          depthTest: false,
        });
        let circle2 = new THREE.Mesh(geometry, material);
        let { x, y, z } = vehicleData.planning?.planningInitPoint;
        let { x: ox, y: oy, z: oz } = vehicleData.origin;
        circle2.position.set(x - ox, y - oy, 0);
        group_vehiclePlanning.add(circle2);
      }
    }
  } else {
    if (group_vehiclePlanning) {
      group_vehiclePlanning.timeEx--;
      if (group_vehiclePlanning.timeEx <= 0) {
        disposeO3D(group_vehiclePlanning);
        group_vehiclePlanning = null;
      }
    }
  }
};

/**
 * 根据配置，设置停靠点显示隐藏
 * @param {*} e
 */
export function visible_planning(e) {
  // visible_group = e.includes('/planning/planning_result');
  // if (group_vehiclePlanning) {
  //   group_vehiclePlanning.visible = visible_group;
  // }
}

export function clear_planning_group() {
  if (group_vehiclePlanning) {
    disposeO3D(group_vehiclePlanning);
  }
}
